module.exports = __webpack_public_path__ + "static/media/puma-coming.350eccea.png";